// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#disclaimer {\n  background-color: #5b5b5b;\n  color: #fff;\n  padding: 1em 0;\n}\n\n#footer {\n  padding: 2.1em 0;\n  background: #333;\n  color: #fff;\n  text-align: center;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
